
const digest = '0df9f47384e9bb39e37f4ffe6635428a697bbade99e2987666f9244a26457925';
const classes = {"status":"_status_13gnq_1","list":"_list_13gnq_8","item":"_item_13gnq_14"};
const css = `._status_13gnq_1 {
  padding: 12px 20px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  color: #6c757d;
}

._list_13gnq_8 {
  list-style: none;
  margin: 0;
  padding: 0;
}

._item_13gnq_14 {
  padding: 12px 20px;
  cursor: pointer;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  transition: background-color 0.15s ease;
}
._item_13gnq_14:hover {
  background-color: rgba(22, 101, 216, 0.08);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  